import { incrementCounter } from "@snapchat/web-graphene-reporting";
import { LENS_CATEGORY } from "../../../../constants/categories";
import { TabBanner } from "../../../common/TabBanner";
import { TagBanner } from "../../../common/TagBanner";
import { grafanaBasePrefix } from "../../../../lib/grafana";
function getCategoriesLinks(basePath, link) {
    return link === LENS_CATEGORY.FOR_YOU
        ? `${basePath}/`
        : `${basePath}/category/${link.toLowerCase()}`;
}
function getBannerItem(basePath, category, index, logLinkClick, onSelect) {
    return {
        label: category.displayName,
        link: getCategoriesLinks(basePath, category.name),
        isSelected: category.isSelected,
        logLinkClick: logLinkClick,
        index: index,
        onSelect: onSelect,
    };
}
/* istanbul ignore next -- do not test reactions to a user interaction */
function getIncrementCategoryClick(pageName, categoryName) {
    return async () => {
        await incrementCounter(`${grafanaBasePrefix}.${pageName}.Lenses.Category.${categoryName}.Click`, 1);
    };
}
export function CategoriesBanner(props) {
    const categoryItems = props.categories.map((category, index) => getBannerItem(props.basePath, category, index, getIncrementCategoryClick(props.pageName, category.name)));
    return props.isTablet || !props.isMobile ? (<TagBanner tagItems={categoryItems}/>) : (<TabBanner tabItems={categoryItems}/>);
}
